<template>
  <modal
      name="info-popup"
      :width="0"
      @before-open="beforeOpen">
      <div
          id="info_modal"
          class="modal modal__400 modal__info show">
          <section>
              <a
                  class="modal__close"
                  @click="hide">
                  <i class="icon-close" />
              </a>
              <div class="modal__head">
                  <img v-if="content.image" :src="content.image" alt="events button" class="events-button" />
              </div>
              <div class="modal__body">
                <p v-html="content.body" />
              </div> 
          </section>
      </div>
    </modal>
  </template>
  
  <script>
      export default {
          name: "InfoPopup",
          data() {
            return {
              content: {
                body: '',
                image: ''
              }
            }
          },
          methods: {
            hide() {
                this.$modal.hide('info-popup')
            },
            beforeOpen(event) {
              if (event?.params) {
                this.content = {
                  body: event.params.body || '',
                  image: event.params.image || ''
                }
              }
            }
          }
      }
  </script>

  <style>
    .modal__info {
      section {
          width: 575px;
          text-align: center;
      }

      .modal__head {
          padding-top: 4rem;

          img {
              width: 200px;
          }

      }

      .modal__body {
          padding: 2rem 4rem;

          p  {
            font-size: 20px;
            line-height: 30px; 
            color: #717680;
          }
      }
    }

    @media (min-width: 991px) {
      .modal__info {
        top: 25% !important;
        left: 25% !important;
        width: 50% !important;
        height: 50% !important;
      }
    }

    @media (max-width: 575px) {
      .modal__info {
        top: 25% !important;
        height: 45% !important;
      }
    }
  </style>